import { cn } from '#lib/utils'

interface SegmentedItem<T extends string | number | boolean> {
  label: string
  value: T
  disabled?: boolean
}

interface SegmentedControlProps<T extends string | number | boolean> {
  items: SegmentedItem<T>[]
  value: T
  onChange: (value: T) => void
  className?: string
}

export function SegmentedControl<T extends string | number | boolean>({
  items,
  value,
  onChange,
  className,
}: SegmentedControlProps<T>) {
  return (
    <div className={cn('flex w-full rounded-full bg-blue-100 p-1', className)}>
      {items.map((item) => {
        const isActive = item.value === value

        return (
          <button
            key={String(item.value)}
            type="button"
            onClick={() => {
              if (!item.disabled) {
                onChange(item.value)
              }
            }}
            className={cn(
              'flex-1 rounded-full px-3 py-1.5 text-sm font-medium transition',
              isActive ? 'bg-white text-blue-600' : 'text-blue-600/70 hover:text-blue-600',
              item.disabled && 'cursor-not-allowed opacity-40'
            )}
          >
            {item.label}
          </button>
        )
      })}
    </div>
  )
}
